import {
	createActionsHook,
	createHook,
	createStore,
	type BoundActions,
	type HookActionsFunction,
	type HookFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import { type StoreChatItem } from '../types';

type State = Record<string, StoreChatItem[]>;

const store = createStore({
	name: 'chatUseMessages',
	initialState: {} as State,
	actions: {
		setMessages:
			(
				conversationId: string,
				messages: StoreChatItem[],
			): (({ setState }: StoreActionApi<State>) => void) =>
			({ setState }) => {
				setState({ [conversationId]: messages });
			},
		getMessages:
			(conversationId: string): (({ getState }: StoreActionApi<State>) => StoreChatItem[]) =>
			({ getState }) => {
				return getState()[conversationId] ?? [];
			},
	},
});

export const useChatMessages: HookFunction<
	StoreChatItem[],
	BoundActions<
		State,
		{
			setMessages: (
				conversationId: string,
				messages: StoreChatItem[],
			) => ({ setState }: StoreActionApi<State>) => void;
			getMessages: (
				conversationId: string,
			) => ({ getState }: StoreActionApi<State>) => StoreChatItem[];
		}
	>,
	{
		conversationId: string;
	}
> = createHook(store, {
	selector: (state, { conversationId }: { conversationId: string }) => state[conversationId] ?? [],
});
export const useChatMessagesActions: HookActionsFunction<
	BoundActions<
		State,
		{
			setMessages: (
				conversationId: string,
				messages: StoreChatItem[],
			) => ({ setState }: StoreActionApi<State>) => void;
			getMessages: (
				conversationId: string,
			) => ({ getState }: StoreActionApi<State>) => StoreChatItem[];
		}
	>
> = createActionsHook(store);
